const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
export const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

export const styles = (theme) => {
    return {
        formHeader:{
            display:"flex",
            justifyContent: "space-between",
        },
        formControl: {
            margin: theme.spacing(1),
            minWidth: 120,
            width: "100%"
        },

        chips: {
            display: "flex",
            flexWrap: "wrap",
        },
        chip: {
            margin: 2,
        },
        noLabel: {
            marginTop: theme.spacing(3),
        },
        searchContainer: {
            overflowX: "hidden",
            maxHeight: "calc(100vh - 120px)",
            overflowY:"auto",
            paddingBottom:5
        }
    };
};
export const toolBarStyles = (theme) => {
    return {
        ...styles(theme),
        button: {
            marginRight: theme.spacing(1),
            marginTop:"15px",
            float:"right"
        },
        editIcon: {
            marginTop:"15px",
            marginLeft:5
        }
    };
};
